import Vue from "vue";

const state = {
  user_email: null,
  payment_id: null,
  is_bank_account_change: false,
  uuid: null,
  has_accepted_tos: false,
  license_plate: null,
  license_plate_country_code: null
};

const actions = {
  subscriptions(context, payload) {
    return Vue.prototype.$http.get("/api/customer-subscriptions/v1" + payload);
  },
  putSubscription(context, payload) {
    return Vue.prototype.$http.put(
      "/api/customer-subscriptions/v1/" + payload.uuid,
      payload
    );
  },
  postSubscription(context, payload) {
    return Vue.prototype.$http.post("/api/customer-subscriptions/v1", payload);
  },
  cancelSubscription(context, payload) {
    return Vue.prototype.$http.put(
      `/api/customer-subscriptions/v1/${payload.uuid}/cancel`,
      {
        subscription_end_date: payload.subscription_end_date
      }
    );
  },
  getCancellationDates(context, payload) {
    return Vue.prototype.$http.get(
      `/api/customer-subscriptions/v1/${payload}/cancellation-end-dates`
    );
  },
  subscribe(context) {
    const payload = {
      user_email: context.state.user_email,
      payment_provider_redirect_url:
        window.location.origin + "/invoice-online-payment-result",
      subscription_uuid: context.state.uuid,
      has_accepted_tos: context.state.has_accepted_tos
    };
    Vue.prototype.$http
      .post("/api/invoice-online-payment/v1", payload)
      .then(response => {
        context.commit("payment_id", response.data.payment_id);
        window.location.href = response.data.mollie_url;
      });
  },
  subscribe_already_registered(context) {
    const payload = {
      user_email: context.state.user_email,
      payment_provider_redirect_url:
        window.location.origin + "/mandate-payment-redirect",
      subscription_uuid: context.state.uuid,
      has_accepted_tos: context.state.has_accepted_tos,
      license_plate: context.state.license_plate,
      license_plate_country_code: context.state.license_plate_country_code
    };
    return Vue.prototype.$http
      .post("/api/customer-subscriptions/v1/mandate", payload)
      .then(response => {
        context.commit("payment_id", response.data.payment_id);
        context.commit("is_bank_account_change", false);
        window.location.href = response.data.mollie_url;
      });
  },
  setRegisterData(context, payload) {
    context.commit("set_register_data", payload);
  },
  getResult(context) {
    return Vue.prototype.$http.get(
      "/api/invoice-online-payment/v1/" + context.state.payment_id
    );
  }
};

const mutations = {
  payment_id(state, payload) {
    state.payment_id = payload;
  },
  is_bank_account_change(state, payload) {
    state.is_bank_account_change = payload;
  },
  set_register_data(state, payload) {
    state.user_email = payload.user_email;
    state.uuid = payload.uuid;
    state.has_accepted_tos = payload.has_accepted_tos === true;
    state.license_plate = payload.license_plate || null;
    state.license_plate_country_code =
      payload.license_plate_country_code || null;
  }
};
const getters = {};

export const subscription = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
